import { addNotify } from 'features/Notify';
import { actions as authActions } from 'features/Auth';
import { actions as historyActions } from 'features/History';
import { actions as megaWinsActions } from 'features/MegaWins';
import { statuses } from '../data';
import { roundingFunc } from 'services/helpers/roundingFunc';

const actionTypes = {
  GET_SETTINGS_SUCCESS: 'game/GET_SETTINGS_SUCCESS',
  SET_START_INFO: 'game/SET_START_INFO',
  COMPLETE_GAME: 'game/COMPLETE_GAME',
  SET_IS_PROCESS: 'game/SET_IS_PROCESS',
  START_GAME: 'game/START_GAME',
  SET_GAME_SETTINGS: 'game/SET_GAME_SETTINGS',
  CLEAN_WRONG_PICKS: 'game/CLEAN_WRONG_PICKS',
  PICK: 'game/PICK',
  WRONG: 'game/WRONG',
  WON: 'game/WON',
  LOST: 'game/LOST',
}

const getSettings = data => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.GET_SETTINGS_SUCCESS, payload: data });
}

const setStartInfo = data => dispatch => {
  dispatch({ type: actionTypes.SET_START_INFO, payload: data })
}

const startGame = callback => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { currency, token } = getState().auth;
  const { locale } = getState().locale;
  const { isProcess, gameSettings } = getState().game;
  if (!isProcess) {
    dispatch({ type: actionTypes.SET_IS_PROCESS, payload: true });
    const response = await api.game.startGame({
      amount: gameSettings.amount,
      lines_count: gameSettings.linesCount,
      players_count: gameSettings.playersCount,
      pre_pick: { 
        is_pre_picked: gameSettings.isAutoPick,
        pre_pick_data: gameSettings.autoPickData
      } }, token);
    if (response.success) {
      if (!gameSettings.isAutoPick) {
        dispatch({ type: actionTypes.START_GAME, payload: { ...gameSettings, game_id: response.data.game_id } })
        dispatch(authActions.getBalance(response.data.new_balance))
        dispatch(addNotify(locale.placeBetSuccess(gameSettings.amount, currency), 'success'));
      } else {
        dispatch(authActions.getBalance(response.data.new_balance));
        if (response.data?.status === 1) {
          dispatch({ type: actionTypes.COMPLETE_GAME, payload: { ...response.data, temp_pick: gameSettings.autoPickData } })
          dispatch(authActions.getBalance(response.data.new_balance))
          dispatch(addNotify(`${locale.youWon} ${roundingFunc(+response.data?.win_amount)} ${currency}`, 'win'))
        }
        if (response.data?.status === 2) {
          await dispatch({ type: actionTypes.CLEAN_WRONG_PICKS })
          const wrongIndex = gameSettings.autoPickData.split('').findIndex((t, i) => response.data.result?.[i] !== t)
          dispatch({ type: actionTypes.LOST, payload: { ...response.data, stepId: wrongIndex, glassId: +gameSettings.autoPickData[wrongIndex] } });
          dispatch(addNotify(locale.tryAgain, 'error'))
        }
      }

      if (callback) {
        callback();
      }
    } else {
      dispatch(addNotify(locale.errorMessages[response?.codeStatus?.toString()] || locale.errorMessages.defaultMessage, 'error'));
    }
    dispatch({ type: actionTypes.SET_IS_PROCESS, payload: false });
  }
}

const completeGame = callback => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { currency, token } = getState().auth;
  const { locale } = getState().locale;
  const { roundID, isProcess, gameSettings } = getState().game;
  if (!isProcess) {
    dispatch({ type: actionTypes.SET_IS_PROCESS, payload: true });
    const response = await api.game.completeGame({ round_id: roundID }, token);
    if (response.success) {
      dispatch({ type: actionTypes.COMPLETE_GAME, payload: response.data })
      dispatch(authActions.getBalance(response.data.new_balance));
      if (+response.data.win_amount/gameSettings.amount >= 20) {
        dispatch(megaWinsActions.showMegaWins(+response.data?.win_amount));
      }
      else {
        dispatch(addNotify(`${locale.youWon} ${roundingFunc(+response.data?.win_amount)} ${currency}`, 'win'))
      }
      dispatch(historyActions.updateBet({ roundID, win_amount: +response.data.win_amount || 0 }))
      if (callback) {
        callback();
      }
    } else {
      dispatch(addNotify(locale.errorMessages[response?.codeStatus?.toString()] || locale.errorMessages.defaultMessage, 'error'));
    }
    dispatch({ type: actionTypes.SET_IS_PROCESS, payload: false });
  }
}

const pick = data => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { locale } = getState().locale;
  const { roundID, isProcess, temp_pick } = getState().game;
  const { token } = getState().auth;

  if (!isProcess) {
    dispatch({ type: actionTypes.SET_IS_PROCESS, payload: true });
    const response = await api.game.pick({ round_id: roundID, temp_pick: temp_pick + data.glassId.toString() }, token);
    if (response.success) {
      const responseData = response.data;
      switch (responseData.status) {
        case statuses.inPlay:
          {
            if (responseData.is_correct) {
              dispatch({ type: actionTypes.PICK, payload: temp_pick + data.glassId.toString() });
            } else {
              dispatch({ type: actionTypes.WRONG, payload: { ...data, lives: responseData.lives } });
            }
            break;
          }
        case statuses.won:
          {
            dispatch({ type: actionTypes.PICK, payload: temp_pick + data.glassId.toString() });
            dispatch(addNotify(locale.gameCompleted, 'win'));
            break;
          }
        case statuses.lost:
          {
            dispatch({ type: actionTypes.LOST, payload: { ...data, ...responseData } });
            dispatch(addNotify(locale.tryAgain, 'error'))
            break;
          }             
        default: break;  
      }
    } else {
      dispatch(addNotify(locale.errorMessages[response?.codeStatus?.toString()] || locale.errorMessages.defaultMessage, 'error'));
    }
    dispatch({ type: actionTypes.SET_IS_PROCESS, payload: false });
  }
}

const setGameSettings = data => async (dispatch, getState, extra) => {
  const { autoPickData } = getState().game.gameSettings;
  const { locale } = getState().locale;
  if (data.isAutoPick && !autoPickData) {
    dispatch(addNotify(locale.chooseYourWay, 'success'))
  }
  dispatch({ type: actionTypes.SET_GAME_SETTINGS, payload: data });
}

export {
  actionTypes,
  getSettings,
  setStartInfo,
  setGameSettings,
  pick,
  startGame,
  completeGame,
}